import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'crowdctrl-form-actions',
  standalone: true,
  templateUrl: './form-actions.component.html',
  styleUrl: './form-actions.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class FormActionsComponent {}
